import styled from 'styled-components';

import { styledReset, styledTypography } from '@pkg/primitives';

interface SectionProps {
    $hidden?: boolean;
    $compact?: boolean;
}
export const PageContentWrapper = styled.div<SectionProps>`
    width: 100%;
    max-height: ${({ $compact }) => ($compact ? '250px' : 'calc(100vh - 80px)')}; //admin nav height
    display: flex;
    height: 100%;
    flex-direction: column;
`;

export const HeaderSection = styled.div`
    display: flex;
    flex: 0 1 auto;
    justify-content: space-between;
    align-items: center;
    button {
        display: flex;
        gap: 8px;
    }
    svg {
        display: flex;
        fill: currentColor;
        width: 20px;
    }
`;

export const MarkdownEditorWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 6px;
    flex-direction: row;
    flex: 1 1 auto;
    overflow-x: scroll;
`;

export const Section = styled.div<SectionProps>`
    width: 100%;
    flex-direction: column;
    display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
    flex: 1 1 auto;
    gap: 10px;
`;
export const SectionWrapper = styled.div`
    display: flex;
    padding: 10px;
    width: 100%;
    flex: 1 1 auto;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.shades.white[50]};
    flex-direction: column;
    overflow-x: scroll;
`;
export const EditorInput = styled.textarea`
    ${styledReset.input};
    ${styledTypography.allianceBase};
    min-width: 100%;
    height: 100%;
    background: transparent;
    color: ${({ theme }) => theme.shades.white[80]};
    overflow-x: scroll;
    resize: none;
`;

export const ControlsSection = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: 0 1 auto;
    gap: 10px;
    padding: 10px 0;
`;
